import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {
  RecipientBankAccount,
  RecipientBankAccountStatus,
} from '@gatewee/types/recipient-bank-account';
import {resolveCompeDisplayName} from '@gatewee/helpers';
import {PixKeyPipe} from '@gatewee/utils/pipes/pix-key.pipe';

@Component({
  selector: 'app-withdrawal-step-unlocked',
  templateUrl: './withdrawal-step-unlocked.component.html',
  standalone: false,
})
export class WithdrawalStepUnlockedComponent {
  @Input() form!: FormGroup;
  @Input() recipientInputIconName = '';
  @Input() recipientMask = '';
  @Input() recipientInputType: 'text' | 'email' = 'text';
  @Input() pixKeyCustomMessages: Record<string, string> = {};
  @Input() pixKeyFieldShowsError = false;
  @Input() recipientKindHint: string | null = null;
  @Input() showAmbiguousKindRow = false;
  @Input() manualPixKeyKind: 'cpf' | 'phone' | null = null;
  @Input() lookupPending = false;
  @Input() lookupErrorMessage: string | null = null;
  @Input() bankAccountsLoading = false;
  @Input() contactSearchQuery = '';
  @Input() defaultBankAccount: RecipientBankAccount | null = null;
  @Input() bankAccounts: RecipientBankAccount[] = [];

  @Output() readonly pixKeyFocus = new EventEmitter<void>();
  @Output() readonly pixKeyBlur = new EventEmitter<void>();
  @Output() readonly kindPicked = new EventEmitter<'cpf' | 'phone'>();
  @Output() readonly contactSelected = new EventEmitter<RecipientBankAccount>();

  constructor(private readonly pixKeyPipe: PixKeyPipe) {}

  bankDisplayNameForAccount(account: RecipientBankAccount): string {
    const code = account.compeCode;
    if (!code) {
      return `PIX: ${this.pixKeyPipe.transform(
        account.pixKey,
        account.pixKeyType,
      )}`;
    }
    return resolveCompeDisplayName(code);
  }

  isBankAccountSelectable(account: RecipientBankAccount): boolean {
    return account.status === RecipientBankAccountStatus.ACTIVE;
  }

  statusLabelKey(account: RecipientBankAccount): string {
    return `enums.recipientBankAccountStatus.${account.status}`;
  }

  onContactClick(account: RecipientBankAccount): void {
    if (!this.isBankAccountSelectable(account)) {
      return;
    }
    this.contactSelected.emit(account);
  }
}
